import InstallNodePackageManagers from "../../../../contents/docs/integrate/_snippets/install-node-package-managers.mdx";
import * as React from 'react';
export default {
  InstallNodePackageManagers,
  React
};